import {useNavigate, useParams} from "react-router-dom";
import {useAppSelector} from "../../feature/tools";
import {useEffect} from "react";
import {User} from "../../feature/project/User";

export type Role = 'viewer' | 'editor' | 'owner' | 'creator'

export const anyRole: Role[] = ['viewer', 'editor', 'owner', 'creator']
export const editorRoles: Role[] = ['editor', 'owner', 'creator']
export const ownerRoles: Role[] = ['owner', 'creator']
export const creatorRoles: Role[] = ['creator']

export const WithUserPermission = (props: { children: any, roles: Role[], navigateTo?: string }) => {
    const user = useAppSelector(state => state.users.currentUser)

    return (<>{user && user.role && props.roles.map(r => r.toString()).includes(user.role) ? props.children : undefined} </>)
}

export const NavigateWithUserPermission = (props: { children: any, roles: Role[], navigateTo?: string }) => {
    const user = useAppSelector(state => state.users.currentUser)
    const navigate = useNavigate()
    const {projectId, storyId} = useParams()

    useEffect(() => {
        if (user && user.role && !props.roles.map(r => r.toString()).includes(user.role)) {
            navigate(props.navigateTo || `/projects/${projectId}/stories/${storyId}`)
        }
    }, [user]);

    return (<>{!user?.role ? undefined : props.children} </>)
}

export const hasRoles = (user: User | undefined, roles: Role[]): boolean => {
    return user != undefined && user.role != undefined && roles.map(r => r.toString()).includes(user.role)
}